export const PLANTILLAS_RECEIVED = "PLANTILLAS_RECEIVED";
export const SET_NOMBRE_PLANTILLA = "SET_NOMBRE_PLANTILLA";
export const SET_PLANTILLA = "SET_PLANTILLA";
